import { TradeVenue } from '@/types/generated/common/types'

export interface VenueScopedTradingRow {
  accountId: string
  tradeVenue: TradeVenue
}

export interface TradingVenueScope {
  targetVenue: TradeVenue | undefined
  activeAccountIds?: ReadonlySet<string>
  accountVenueById: ReadonlyMap<string, TradeVenue>
}

export function matchesTradingVenue(
  row: VenueScopedTradingRow,
  { targetVenue, activeAccountIds, accountVenueById }: TradingVenueScope
): boolean {
  if (targetVenue === undefined || targetVenue === TradeVenue.TRADE_VENUE_UNSPECIFIED) {
    return false
  }

  if (activeAccountIds && (!row.accountId || !activeAccountIds.has(row.accountId))) {
    return false
  }

  if (row.tradeVenue !== TradeVenue.TRADE_VENUE_UNSPECIFIED) {
    return row.tradeVenue === targetVenue
  }

  return accountVenueById.get(row.accountId) === targetVenue
}
